import uuid from "uuid";
import { push } from "connected-react-router";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, flatMap } from "rxjs/operators";
import {
	onInductionMinutesListRequest,
	TASK_INDUCTION_MINUTES_ROUTE,
} from "features/health-and-safety";
// import { createSitePath, SITE_INDUCTION_MINUTES_PATH } from 'features/sites'
import { ADD_INDUCTION_MINUTES_FORM_SUBMIT } from "../actions/types";
// import { getResponseBody } from '../utils'
import {
	DBService,
	INDUCTION_MEETINGS_TABLE,
	replaceDataURLs,
	authHeaders,
	getOrganisationBaseUrl,
} from "frame";
import { filterPeople, getCurrentTimestamp } from "utils";
import * as R from "ramda";

import {
	onAddInductionMinutesReset,
	onAddInductionMinutesSaveFailed,
	onAddInductionMinutesSaveSuccess,
} from "../actions";

const fetchAttachments = () => async () => {
	const db = new DBService();
	var files = await db.getAll(INDUCTION_MEETINGS_TABLE);
	return files;
};

const addInductionMinutesEffect = (action$, state$) =>
	action$.pipe(
		ofType(ADD_INDUCTION_MINUTES_FORM_SUBMIT),
		flatMap(fetchAttachments()),
		mergeMap((result) => {
			const formState = R.clone(
				state$.value.addInductionMinutesFormReducer
			);

			// Normalise attachments
			const attachments = Array.isArray(formState.attachments)
				? replaceDataURLs(formState.attachments, result)
				: [];

			// Creator info from profile (for CreatorId / CreatorName validation)
			const profile = state$.value.profile || {};
			const creatorId =
				profile.userId || profile.id || profile.staffId || "";
			const creatorName =
				profile.fullName ||
				`${profile.firstName || ""} ${profile.lastName || ""}`.trim();

			return ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/induction-minutes/createorupdate`,
					{
						id: formState.id || uuid.v4(),
						siteId: formState.siteId,
						createdAt: formState.createdAt,
						creatorId: creatorId,
						creatorName: creatorName,
						people: filterPeople(formState.people),
						otherPeople: formState.otherPeople,
						hazards: formState.hazards,
						hazardousSubstances: formState.substances,
						attachments: attachments,
						notes: formState.notes,
						hazardNotes: formState.hazardNotes,
						appendNotes: formState.appendNotes,
						sendReminder: formState.sendReminder,
						recipients: formState.recipients,
						recipientsOther: formState.recipientsOther,
						sendEmail: formState.sendToRecipientsOnSave,
						latitude: state$.value.geolocation.latitude,
						longitude: state$.value.geolocation.longitude,
						timestamp: getCurrentTimestamp(),
						organisationId:
							state$.value.organisations.currentOrganisation,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							onInductionMinutesListRequest(),
							onAddInductionMinutesSaveSuccess(),
							onAddInductionMinutesReset(),
							push(TASK_INDUCTION_MINUTES_ROUTE)
						)
					),
					catchError((error) => of(onAddInductionMinutesSaveFailed()))
				);
		})
	);

export default addInductionMinutesEffect;
